import { Component, Input, OnChanges } from '@angular/core';
import { CellData, TabData, TabUtil } from '@ddt-web/data-service';
import * as cloneDeep from 'lodash/cloneDeep';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';

@Component({
	selector: 'ac-combined-data-table',
	templateUrl: './combined-data-table.component.html',
	styleUrls: ['./combined-data-table.component.scss']
})
export class CombinedDataTableComponent implements OnChanges {
	@Input() public tabs: TabData[];
	@Input() public isStriped: boolean = false;
	@Input() public isBordered: boolean = false;
	@Input() public isPadded: boolean = false;
	@Input() public columnWidths: number[];
	@Input() public excludeColumns?: string[];
	// use this when HeadersY is not the portfolio name, you can specify column from HeadersX to act as your HeadersY instead
	@Input() public specificColumnAsHeaderY?: string;
	@Input() public isZebraColor: boolean = false;
	// use this when the tables don't have a matching number of rows and you need to create a dummy empty rows
	// you still need to include the empty rows in the TabData before passing to this component
	@Input() public ignoreEmptyRow: boolean = false;
	@Input() public tableIndex: number = 0;

	public combinedCells: CellData[][][] = [];
	public headersY = [];
	public headersX = [];

	public ngOnChanges(): void {
		if (this.tabs && this.tabs.length) {
			const updatedTabs = this.updateTabs(); // set updateTabs to new const, otherwise tabs will be changed (removed)
			this.headersX = updatedTabs.map(tab => get(tab, ['tableData', this.tableIndex, 'headersX'], [])).filter(headersX => !isEmpty(headersX)).shift() || [];
			if (this.specificColumnAsHeaderY) {
				const columnAsHeadersYIndex = get(this.tabs[0], ['tableData', this.tableIndex, 'headersX'], []).findIndex(headerX => headerX?.config.id === this.specificColumnAsHeaderY);
				this.headersY = get(this.tabs[0], ['tableData', this.tableIndex, 'cells'], []).map(row => row[columnAsHeadersYIndex]);
			} else {
				this.headersY = get(updatedTabs[0], ['tableData', this.tableIndex, 'headersY'], []).filter(header => header.formattedValue); // filter formatted value for ST where we have asset classes
			}
			this.combinedCells = updatedTabs.map(tab => get(tab, ['tableData', this.tableIndex, 'cells'], [])).filter(cells => cells);
		}
	}

	private updateTabs(): TabData[] {
		let updatedTabs = cloneDeep(this.tabs).map(tab => TabUtil.getVisibleTabData(tab, this.ignoreEmptyRow));

		if (!isEmpty(this.excludeColumns)) {
			updatedTabs = updatedTabs.map(tab => TabUtil.getFilteredTabData(tab, this.excludeColumns));
		}

		return updatedTabs;
	}
}
